<template>
    <div class="redflags-logo" v-on="$listeners">
        <img :src="`${publicPath}datlab_logo.svg`"><div>KONTROLA</div>
    </div>
</template>

<script>
export default {
    name: "redflags-logo",
    computed: {
        publicPath: function() {
            return import.meta.env.BASE_URL
        }
    }
};
</script>

<style lang="scss">
@use "@/scss/custom";

.redflags-logo {
    color: custom.$secondary;
    font-weight: 800;
    font-size: 20px;
    line-height: 1;

    a {
        color: custom.$body-color;
        text-decoration: none;

        &:hover {
            text-decoration: none;
        }
    }
}
</style>
